'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _tracker = require('@beastshop/tracker');

var _axiosM = require('@beastshop/axios-m');

var _axiosM2 = _interopRequireDefault(_axiosM);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _browser = require('@beastshop/browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var page = location.href;
var referrer = document.referrer;
var markting = _jsCookie2.default.get('ac');

if (!(0, _browser.app)()) {
  var pv_data = (0, _tracker.pv)(markting, page, referrer);
  _send(pv_data);
}

function _send(data) {
  (0, _axiosM2.default)({
    method: 'POST',
    url: '/_track/app',
    form: {
      // m: cookie.get('member_id'),
      t: +new Date(),
      d: data
    }
  }).catch(function (e) {});
}

exports.default = function (arg) {
  var t = _extends({}, arg, {
    page: page,
    referrer: referrer,
    markting: markting
  });
  var t_data = (0, _tracker.track)(t);
  _send(t_data);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/tracker-m/lib/wrap-track.js
// module id = 963
// module chunks = 0